<p-inputGroup>
    <input #champNumero type="text" pInputText [(ngModel)]="numero" autocomplete="off" autofocus
        (keyup)="verifierNumero()" />
    <button *ngIf="!validationEnCours" pButton pRipple icon="pi pi-search" label="Prochain" class="p-button-primary"
        (click)="obtenirProchainNumero()" [disabled]="isProchainDisabled"></button>
    <p-inputGroupAddon *ngIf="validationEnCours">
        <i class="pi pi-spinner pi-spin"></i>
    </p-inputGroupAddon>
</p-inputGroup>
<small *ngIf="numeroValide === true " style="color: green;">Numéro valide</small>
<small *ngIf="numeroValide === false" style="color: red;">Numéro déjà existant</small>

<div class="mt-4 flex justify-content-end gap-2">
    <p-button label="Confirmer" [disabled]="!numero" class="p-button-primary" icon="pi pi-check" iconPos="left"
        (onClick)="Confirmer()"></p-button>
    <p-button label="Annuler" text icon="pi pi-ban" iconPos="left" (onClick)="Annuler()"></p-button>
</div>